import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';
import GuidHeaderDetails from '../orgGuidDetails/guidHeaderDetails/GuidHeaderDetails';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import DetailsImageDisplay from '../../../components/detailsImageDisplay/DetailsImageDisplay';
import DetailsTab from '../../../components/orgDetails/detailsTab/DetailsTab';
import OrgDateTab from '../../../components/orgDetails/orgDateTab/OrgDateTab';
import styles from './orgActivityDetails.module.css';
import fetchOrgActData from './orgActDetailsFun/fetchOrgActData';
import OrgSlotTab from '../../supOrgTripDetails/supOrgActivityDetails/actSlotAdd/ActSlotTab';
import { orgAddTimeSlot } from '../../../api/orgActAPI';

const OrgActivityDetails = () => {
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activityData, setActivityData] = useState({});
    const [isExpanded, setIsExpanded] = useState(false);
    const refresh = () => {
        setLoad(!load);
    };

    useEffect(() => {
        fetchOrgActData(setLoading, setActivityData);
        //eslint-disable-next-line
    }, [load]);

    const context = {
        role: 'org',
        flow: 'activity'
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate('/org/a/my-activity')}>
                <img src={BackIcon} alt='back' /> Back to Packages
            </button>
            {Object.keys(activityData).length !== 0 && (
                <div className='orgTripDetailsLayout'>
                    <div className='tripDetailsMainRow'>
                        <div className='tripDetailsLeft'>
                            <GuidHeaderDetails guidData={activityData} />

                            <DetailsImageDisplay imageData={activityData?.images || []} />
                            <DetailsTab
                                whichSection={'org'}
                                context={context}
                                data={activityData}
                                type={'act'}
                                refresh={refresh}
                            />
                        </div>
                        <div className='tripDetailsBookingUser'>
                            <OrgSlotTab
                                data={activityData}
                                type={'act'}
                                addTimeSlot={orgAddTimeSlot}
                                isExpanded={isExpanded}
                                setIsExpanded={setIsExpanded}
                                refresh={refresh}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrgActivityDetails;
